/* eslint-disable max-len */

/** フロントエンド URL */
const FRONT_DOMAIN = 'd2e3xmk2pvbp1g.cloudfront.net';
const FRONT_URL = `https://${FRONT_DOMAIN}`;

/** バックエンド URL */
const BACK_DOMAIN = FRONT_DOMAIN;
const API_URL = `https://${BACK_DOMAIN}/api/inner/`;

export default {
  'logger': false,
  'consolelog': true,
  'API_URL': API_URL,
  'WIJMO_LICENSE_KEY': `${FRONT_DOMAIN},`,
  'MANUAL_PDF_URL': `${FRONT_URL}/manual/manual.pdf`,

  /** Cognito認証設定 */
  'amplify_conf': {
    Auth: {
      // REQUIRED - Amazon Cognito Region
      region: 'ap-northeast-1',
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'ap-northeast-1_5Hrkpht7u',
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '206gm5rvjk3vjhpp3290pj8cja',
      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: false,
    },
  },
};
